var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKnowledgeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "40.000000pt",
    height: "40.000000pt",
    viewBox: "0 0 40.000000 40.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,40.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 354 c-4 -4 -7 -15 -7 -25 0 -9 -6 -20 -12 -23 -10 -5 -10 -7 0 -12 14 -7 16 -40 2 -49 -6 -4 -5 -13 3 -25 9 -16 9 -24 0 -40 -8 -12 -9 -21 -3 -25 14 -9 12 -42 -3 -48 -9 -4 -9 -8 -1 -14 7 -4 13 -17 15 -28 4 -19 12 -20 129 -20 l125 0 0 155 0 155 -121 3 c-66 1 -123 -1 -127 -4z m223 -154 l0 -140 -100 0 -100 0 0 140 0 140 100 0 100 0 0 -140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 286 c-3 -8 -4 -25 -2 -38 3 -22 7 -23 78 -23 l75 0 0 35 0 35 -73 3 c-56 2 -74 0 -78 -12z m126 -26 c0 -5 -22 -10 -50 -10 -27 0 -50 5 -50 10 0 6 23 10 50 10 28 0 50 -4 50 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeImage);
export default __webpack_public_path__ + "static/media/knowledgeImage.d953d4f77fb01ea37b274ff84fa10234.svg";
export { ForwardRef as ReactComponent };